import axios from "axios";
const uri = "https://www.lefisc.com.br/api/monitoramentoNCM/Cliente";
const tok = "64ad62a25fe48a9e8bcd84df737dd40b";
const uriNCM = "dadosNCM";
const uriEmail = "emailCliente";
const uriMonitorar = "monitorar";

export default {
  async getDadosNCM(numNCM) {
    return await axios
      .get(`${uri}/${uriNCM}/${numNCM}/${tok}`)
      .then(res => {
        return res.data;
      })
      .catch(err => err);
  },
  async getEmails(idCliente) {
    return await axios
      .get(`${uri}/${uriEmail}/${idCliente}/${tok}`)
      .then(res => {
        return res.data;
      })
      .catch(err => console.error(err));
  },
  async comecarAMonitorar(ncm) {
    return await axios.post(`${uri}/${uriMonitorar}/${tok}`, ncm).then(
      res => {
        return res.data;
      },
      err => {
        console.error(err);
      }
    );
  }
};
